import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/glp-common/components/alert-dialog/alert-dialog.component';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { AuthService } from '@auth0/auth0-angular';
import { ActivityType } from 'src/app/models/ActivityType';
import { MemberDataService } from 'src/app/content/home/services/member-data.service';
import { environment } from 'src/environments/environment';
import { DeniedDialogComponent } from 'src/app/glp-common/components/denied-dialog/denied-dialog.component';
import { TelementryService } from 'src/app/services/telemetry.service';
import * as Sentry from "@sentry/angular";
import { getPortalVersion, PortalVersion } from 'src/app/portal-config';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  name: string;
  groupName: string = '';
  showNavBar: boolean = false;
  userEmail: string;
  isActiveBroker: boolean = false;
  brokerPortalUrl: string;
  smallGroupPortalUrl: string;
  individualPortalUrl: string;
  empoweredMarginsSSOUrl: string;
  eyemedProviderUrl: string;
  softheonSSOUrl: string;
  bavvySSOUrl: string;
  benefitFocusSSOUrl: string;
  bhiWhyzenSSOUrl: string;
  connectureSSOUrl: string;
  litmosSSOUrl: string;
  NebraskaBlueSSOURL: string;
  SAPSSOUrl: string;
  showHeader: boolean = true;
  showEHALinks: boolean = false;
  showASOBilling: boolean = false;

  // Collapsible menu section states
  smallGroupExpanded: boolean = false;
  individualExpanded: boolean = false;
  reportsExpanded: boolean = false;
  brokerManagementExpanded: boolean = false;
  constructor(
    private dialog: MatDialog,
    private router: Router,
    public userService: UserService,
    public auth: AuthService,
    private DataSource: MemberDataService,
    private telementryService: TelementryService,
  ) {}

  ngOnInit(): void {
    this.DataSource.currentMessageSubscriber.subscribe((reload: any) => {
      
      if(reload.isReload){
        this.LoadHeader();
      }
      if (this.userService.isBrokerUser() && this.groupName.length == 0) {
        this.showHeader = false;
      }
      if (this.userService.isGroupLeaderUser()) {
        if (!this.userService.groupLeaderAccountIsSelected) {
          this.showHeader = false;
        }
        if(this.userService.isGroupLeaderEHAUser()){
          this.showEHALinks = true;
        }
      }

      this.showASOBilling = this.userService.showAsoBilling();
    }) 
    
     if (this.userService.isBrokerUser()) {
      this.showNavBar = true;
    }


    this.setLinksBasedOnEnvironment();
    const errorDialogConfig = new MatDialogConfig();
    this.name = this.userService.user.firstName + " " + this.userService.user.lastName;
    this.userEmail = this.userService.user.email;

    this.isActiveBroker = this.userService.user.IsBroker() && this.userService.user.isActivatedBroker;
  }

  logout(): void {
    let logoutUrl = getPortalVersion() == PortalVersion.EOA ? environment.redirectUrlGL : environment.redirectUrlBroker;
    this.auth.logout({ logoutParams: { returnTo: logoutUrl } });
    this.telementryService.trackActivity(ActivityType.SignOut, "", 3); 
    Sentry.setUser(null);
    this.router.navigate(['logout']);
  }

  navigateForms(): void {
    this.router.navigate(['/home/forms']);
  }

  navigateDocuments(): void {
    this.router.navigate(['/home/documents']);
  }

  navigateContact(): void {
    this.telementryService.trackSentryFeature(ActivityType.ContactButton);
    this.router.navigate(['/home/contact']);
  }

  navigateReports(): void {
    this.router.navigate(['/home/reports']);
  }

  navigateBroker(): void {
    this.router.navigate(['/home/broker']);
  }

  navigateDocumentCenter(): void {
    this.router.navigate(['/home/document-center']);
  }

  navigateGroupLeaderAccounts(): void {
    this.router.navigate(['/home/GroupLeaderAccounts']);
  }

  navigateNotifications(): void {
    this.telementryService.trackActivity(ActivityType.OpenNotificationsSection, '', 3);
    this.router.navigate(['/home/notifications']);
  }

  trackHomeActionAndRedirect() {
    this.telementryService.trackActivity(ActivityType.Home, '', 3);
    this.router.navigate(['/home']);
  }

  trackGroupList() {
    var maintenancemode = environment['MaintenanceMode']; 
    if(maintenancemode){
      this.router.navigate(['/home/maintenanceModeGL']);
    }
    else {
      this.userService.groupLeaderAccountIsSelected = false;
      this.router.navigate(['/home/GroupLeaderAccounts']);
    }
  }

  LoadHeader(): void {
    if (this.groupName.length > 0) {
      this.groupName = '';
      return;
    }
    if(this.DataSource.selectedGroupName.length > 0){
      this.groupName = this.DataSource.selectedGroupName;
    }
    this.showHeader = true;
    
  }



  setLinksBasedOnEnvironment(): void {
    this.brokerPortalUrl = environment.redirectUrlBroker;
    this.eyemedProviderUrl = environment.EyeMedProviderURL;
    this.individualPortalUrl = environment.redirectUrlIPP;
    this.smallGroupPortalUrl = environment.redirectUrlSGP;
    this.connectureSSOUrl = environment.ConnectureSSOURL;
    this.litmosSSOUrl = environment.LitmosSSOURL;
    this.SAPSSOUrl = environment.SAPUrl;
    this.softheonSSOUrl = environment.SoftheonSSOURL;
    this.bavvySSOUrl = environment.BavvySSOURL;
    this.bhiWhyzenSSOUrl = environment.WhyzenSSOURL;
    this.benefitFocusSSOUrl = environment.BenefitFocusSSOURL;
    this.empoweredMarginsSSOUrl = environment.EmpoweredMaginsSSOURL;
    this.NebraskaBlueSSOURL = environment.NebraskaBlueSSOURL;
  }

  generatePasswordReset(): void {
    this.telementryService.trackActivity(ActivityType.ResetPassword, "", 4)
    this.userService.resetUserPassword().subscribe(async res => {
      try{
        let dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
          title: 'Password Reset email sent',
          message: 'A email has been sent to you with instructions to reset your password. Please allow up to 5 minutes for the email to be sent.',
          footermessage: ' ',
          logoutOnClose: false
        };
        this.dialog.open(DeniedDialogComponent, dialogConfig);
      }
      catch(error){
        throw error;
      }

    });
  }

  // Toggle methods for collapsible menu sections
  toggleSmallGroup(): void {
    this.smallGroupExpanded = !this.smallGroupExpanded;
  }

  toggleIndividual(): void {
    this.individualExpanded = !this.individualExpanded;
  }

  toggleReports(): void {
    this.reportsExpanded = !this.reportsExpanded;
  }

  toggleBrokerManagement(): void {
    this.brokerManagementExpanded = !this.brokerManagementExpanded;
  }

  handleGtagClick(click_location: string, click_action: string): void {
    window.gTagPush(click_location, click_action);
  }

}
